import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SettingService } from '../../setting/setting.service';

@Component({
  selector: 'app-rate-inspection',
  templateUrl: './rate-inspection.component.html',
})
export class RateInspectionComponent implements OnInit {
  @ViewChild('ratingModal', { static: true }) public ratingModal: ModalDirective;

  confirmCallback: (rating: number, ratingNote: string) => void;
  cancelCallback: () => void;

  ratingForm: UntypedFormGroup;
  customRatingNoteSet = false;

  constructor(
    private fb: UntypedFormBuilder,
    public settingService: SettingService,
  ) {}

  async ngOnInit() {
    this.ratingForm = this.fb.group({
      rating: [10, [Validators.required]],
      ratingNote: [''],
    });
    const ratingNotes = await this.settingService.ratingNotes();
    this.ratingForm.patchValue({ ratingNote: ratingNotes[10] });

    let customRatingNote = '';
    this.ratingForm.get('rating').valueChanges.subscribe(value => {
      if (this.customRatingNoteSet && customRatingNote === '') {
        this.customRatingNoteSet = false;
      }
      if (!this.customRatingNoteSet) {
        customRatingNote = ratingNotes[value];
        this.ratingForm.get('ratingNote').setValue(customRatingNote);
      }
    });

    this.ratingForm.get('ratingNote').valueChanges.subscribe(value => {
      if (value !== ratingNotes[this.ratingForm.get('rating').value]) {
        this.customRatingNoteSet = true;
        customRatingNote = value;
      } else if (value === ratingNotes[this.ratingForm.get('rating').value]) {
        this.customRatingNoteSet = false;
        customRatingNote = '';
      }
    });

    this.ratingModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  async show(options: { confirmed?: (rating: number, ratingNote: string) => void; canceled?: () => void }) {
    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.ratingModal.show();
  }

  async save() {
    if (this.ratingForm.valid) {
      this.ratingModal.hide();
      return (
        this.confirmCallback &&
        this.confirmCallback(this.ratingForm.get('rating').value, this.ratingForm.get('ratingNote').value)
      );
    }
  }

  cancel() {
    this.ratingModal.hide();
    return !!this.cancelCallback && this.cancelCallback();
  }
}
